
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 26 26","width":"35","height":"35"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.867 2.297a1.822 1.822 0 01.21-.176C8.095.813 10.423.113 13.005.113c2.414 0 4.676.668 6.605 1.828.141.082.524.344.72.582-1.864-2.054-7.34 2.356-7.34 2.356-1.891-1.461-3.634-2.457-4.93-2.813-1.086-.296-1.836-.046-2.192.23zm16.57 1.941c-.054-.062-.117-.12-.175-.187-.469-.516-1.047-.64-1.57-.61-.477.153-2.672.942-5.376 3.497 0 0 3.043 2.96 4.91 5.988 1.864 3.027 2.977 5.406 2.294 8.707a12.818 12.818 0 003.343-8.656c0-3.372-1.297-6.446-3.425-8.739zm-4.648 9.98a88.979 88.979 0 00-3.676-3.87c-.355-.352-.73-.72-1.125-1.102 0 0-.593.594-1.363 1.375v-.004c-.988 1-2.27 2.301-2.98 3.063-1.266 1.351-4.895 5.593-5.098 7.972 0 0-.809-1.886.965-6.238 1.156-2.848 4.652-7.117 6.113-8.512 0 0-1.336-1.465-3.008-2.48l-.012-.004s-.02-.016-.046-.031c-.805-.48-1.688-.852-2.532-.903-.863.063-1.41.696-1.41.696a12.81 12.81 0 00-3.48 8.8c0 7.106 5.758 12.864 12.867 12.864 3.77 0 7.16-1.625 9.516-4.211 0-.004-.27-1.7-2-4.133-.41-.57-1.895-2.348-2.73-3.281z"}})])
          )
        }
      }
    